module.exports = __webpack_public_path__ + "img/songfile-footer-logo.2731834c.svg";